import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-f55a9592")

_pushScopeId("data-v-f55a9592")
const _hoisted_1 = { class: "canvas-tool" }
const _hoisted_2 = { class: "left-handler" }
const _hoisted_3 = { class: "add-element-handler" }
const _hoisted_4 = { class: "right-handler" }
const _hoisted_5 = { class: "text" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_IconBack = _resolveComponent("IconBack")
  const _component_Tooltip = _resolveComponent("Tooltip")
  const _component_IconNext = _resolveComponent("IconNext")
  const _component_IconFontSize = _resolveComponent("IconFontSize")
  const _component_IconPicture = _resolveComponent("IconPicture")
  const _component_FileInput = _resolveComponent("FileInput")
  const _component_IconMusic = _resolveComponent("IconMusic")
  const _component_FileAudio = _resolveComponent("FileAudio")
  const _component_IconVideo = _resolveComponent("IconVideo")
  const _component_FileVideo = _resolveComponent("FileVideo")
  const _component_ShapePool = _resolveComponent("ShapePool")
  const _component_IconGraphicDesign = _resolveComponent("IconGraphicDesign")
  const _component_Popover = _resolveComponent("Popover")
  const _component_LinePool = _resolveComponent("LinePool")
  const _component_IconConnection = _resolveComponent("IconConnection")
  const _component_ChartPool = _resolveComponent("ChartPool")
  const _component_IconChartProportion = _resolveComponent("IconChartProportion")
  const _component_TableGenerator = _resolveComponent("TableGenerator")
  const _component_IconInsertTable = _resolveComponent("IconInsertTable")
  const _component_Spin = _resolveComponent("Spin")
  const _component_IconMinus = _resolveComponent("IconMinus")
  const _component_IconPlus = _resolveComponent("IconPlus")
  const _component_IconFullScreen = _resolveComponent("IconFullScreen")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "撤销"
      }, {
        default: _withId(() => [
          _createVNode(_component_IconBack, {
            class: ["handler-item", { 'disable': !_ctx.canUndo }],
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.undo()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"]),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "重做"
      }, {
        default: _withId(() => [
          _createVNode(_component_IconNext, {
            class: ["handler-item", { 'disable': !_ctx.canRedo }],
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.redo()))
          }, null, 8, ["class"])
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ]),
    _createVNode(_component_Spin, {
      tip: "上传中...",
      spinning: _ctx.spinning
    }, {
      default: _withId(() => [
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_Tooltip, {
            mouseLeaveDelay: 0,
            mouseEnterDelay: 0.5,
            title: "插入文字"
          }, {
            default: _withId(() => [
              _createVNode(_component_IconFontSize, {
                class: "handler-item",
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.drawText()))
              })
            ]),
            _: 1
          }, 8, ["mouseEnterDelay"]),
          _createVNode(_component_FileInput, {
            onChange: _cache[4] || (_cache[4] = files => _ctx.insertImageElement(files))
          }, {
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入图片"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconPicture, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }),
          _createVNode(_component_FileAudio, {
            onChange: _cache[5] || (_cache[5] = files => _ctx.insertAudioElement(files))
          }, {
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入音频"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconMusic, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }),
          _createVNode(_component_FileVideo, {
            onChange: _cache[6] || (_cache[6] = files => _ctx.insertVideoElement(files))
          }, {
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入视频"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconVideo, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }),
          _createVNode(_component_Popover, {
            trigger: "click",
            visible: _ctx.shapePoolVisible,
            "onUpdate:visible": _cache[8] || (_cache[8] = ($event: any) => (_ctx.shapePoolVisible = $event))
          }, {
            content: _withId(() => [
              _createVNode(_component_ShapePool, {
                onSelect: _cache[7] || (_cache[7] = shape => _ctx.drawShape(shape))
              })
            ]),
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入形状"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconGraphicDesign, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_Popover, {
            trigger: "click",
            visible: _ctx.linePoolVisible,
            "onUpdate:visible": _cache[10] || (_cache[10] = ($event: any) => (_ctx.linePoolVisible = $event))
          }, {
            content: _withId(() => [
              _createVNode(_component_LinePool, {
                onSelect: _cache[9] || (_cache[9] = line => _ctx.drawLine(line))
              })
            ]),
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入线条"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconConnection, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_Popover, {
            trigger: "click",
            visible: _ctx.chartPoolVisible,
            "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => (_ctx.chartPoolVisible = $event))
          }, {
            content: _withId(() => [
              _createVNode(_component_ChartPool, {
                onSelect: _cache[11] || (_cache[11] = chart => { _ctx.createChartElement(chart); _ctx.chartPoolVisible = false })
              })
            ]),
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入图表"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconChartProportion, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }, 8, ["visible"]),
          _createVNode(_component_Popover, {
            trigger: "click",
            visible: _ctx.tableGeneratorVisible,
            "onUpdate:visible": _cache[15] || (_cache[15] = ($event: any) => (_ctx.tableGeneratorVisible = $event))
          }, {
            content: _withId(() => [
              _createVNode(_component_TableGenerator, {
                onClose: _cache[13] || (_cache[13] = ($event: any) => (_ctx.tableGeneratorVisible = false)),
                onInsert: _cache[14] || (_cache[14] = ({ row, col }) => { _ctx.createTableElement(row, col); _ctx.tableGeneratorVisible = false })
              })
            ]),
            default: _withId(() => [
              _createVNode(_component_Tooltip, {
                mouseLeaveDelay: 0,
                mouseEnterDelay: 0.5,
                title: "插入表格"
              }, {
                default: _withId(() => [
                  _createVNode(_component_IconInsertTable, { class: "handler-item" })
                ]),
                _: 1
              }, 8, ["mouseEnterDelay"])
            ]),
            _: 1
          }, 8, ["visible"])
        ])
      ]),
      _: 1
    }, 8, ["spinning"]),
    _createVNode("div", _hoisted_4, [
      _createVNode(_component_IconMinus, {
        class: "handler-item viewport-size",
        onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.scaleCanvas('-')))
      }),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.canvasScalePercentage), 1),
      _createVNode(_component_IconPlus, {
        class: "handler-item viewport-size",
        onClick: _cache[17] || (_cache[17] = ($event: any) => (_ctx.scaleCanvas('+')))
      }),
      _createVNode(_component_Tooltip, {
        mouseLeaveDelay: 0,
        mouseEnterDelay: 0.5,
        title: "适配屏幕"
      }, {
        default: _withId(() => [
          _createVNode(_component_IconFullScreen, {
            class: "handler-item viewport-size-adaptation",
            onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.setCanvasPercentage(90)))
          })
        ]),
        _: 1
      }, 8, ["mouseEnterDelay"])
    ])
  ]))
})